require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ../~/angular-resource/index.js
// module id = 23
// module chunks = 3